import React, { FunctionComponent } from "react"
import { OverlayTrigger } from "react-bootstrap"
import RoleManagementTableContextMenu from "./RoleManagementTableContextMenu/RoleManagementTableContextMenu"
import roleManagementTableItems from "./RoleManagementTableItems"
import PortalRoleAndAssignmentTypes from "../../types/portalRoleTypes/PortalRoleAndAssignmentTypes"
import ratmService from "../../utils/RATMService"
import ratmPopover from "../../utils/RATMPopover"
import dayjs from "dayjs"
import "./RoleManagementTable.css"

const RoleManagementTableBody: FunctionComponent<{}> = () => {

    const { state, timeFormat } = ratmService
    const { rolesAndAssignments, addOrEditRoleId, deleteRoleId } = state

    const handleMouseLeaveAndEnter = (index: number, isItInYet: boolean) => {
        let elem = document.getElementById(`e837f90554d4f6884a7f5a89da61f17-${index}`)
        if (elem) {
            if (isItInYet) {
                elem.style.display = "flex"
            } else {
                elem.style.display = "none"
            }
        }
    }

    const getAssignmentNames = (raa: PortalRoleAndAssignmentTypes) => {
        return raa.Assignments.map(assignment => assignment.Target || "NA");
    }


    return (
        <tbody>
            {rolesAndAssignments.map((raa, i) =>
                <tr
                    key={i}
                    id={`ae62298e68c74dbbb19a7539608afb58-${raa.Role.PortalRoleId}`}
                    style={
                        {
                            backgroundColor:
                                `${(addOrEditRoleId === raa.Role.PortalRoleId && deleteRoleId === -1) ?
                                    "#ffc10750" : (addOrEditRoleId < 0 && deleteRoleId === raa.Role.PortalRoleId) ?
                                        "#dc354550" :
                                        "unset"}`
                        }}
                    onMouseEnter={() => handleMouseLeaveAndEnter(i, true)}
                    onMouseLeave={() => handleMouseLeaveAndEnter(i, false)}
                >
                    {roleManagementTableItems.map((item, j) =>
                        <td
                            key={j}
                            style={{ maxWidth: item.maxWidth }}
                        >
                            <div className={`RoleManagementTableBodyTdItem ${j === roleManagementTableItems.length - 1 ? "RoleManagementTableBodyTdItemLast" : "RoleManagementTableBodyTdItemNotLast"}`}>
                                {j === 0 &&
                                    <OverlayTrigger placement="top" overlay={ratmPopover("Targets", getAssignmentNames(raa))}>
                                        <div className="RoleManagementTableBodyTdItemAssignmentInfo">
                                            <span className="material-icons">adjust</span>
                                        </div>
                                    </OverlayTrigger>
                                }
                                <div className="RoleManagementTableBodyTdItemInfo">
                                    <p style={{ fontWeight: item.fw }}>
                                        {/*@ts-ignore*/}
                                        {!item.isCheckBox && (item.isDate ? dayjs(raa.Role[item.key]).format(timeFormat) : raa.Role[item.key])}
                                    </p>
                                    {/*@ts-ignore*/}
                                    {item.isCheckBox && <div className={`f7d0c564b742b1b08d7cf22ea65b02 ${raa.Role[item.key] ? "f7d0c564b742b1b08d7cf22ea65b02Yes" : "f7d0c564b742b1b08d7cf22ea65b02No"}`}>
                                        {/*@ts-ignore*/}
                                        <span className="material-icons">{`${raa.Role[item.key] ? "done" : "close"}`}</span>
                                    </div>}
                                </div>
                                {j === roleManagementTableItems.length - 1 &&
                                    <div className="RoleManagementTableBodyTdItemContextMenuWrapper">
                                        <RoleManagementTableContextMenu index={i} PortalRoleId={raa.Role.PortalRoleId} />
                                    </div>
                                }
                            </div>
                        </td>
                    )}
                </tr>
            )}
        </tbody>
    )
}

export default RoleManagementTableBody

